import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { HiOutlineLogout, HiOutlineUser, HiOutlineClipboardCheck, HiOutlineDocumentText, HiOutlineCash, HiOutlineMoon, HiOutlineSun, HiOutlineMenu } from 'react-icons/hi';
import Swal from 'sweetalert2';
import '../css/nav.css';
import UserControlPage from './UserControlPage';
import ControlPage from './ControlPage';
import NotesPage from './Kanban/NotesPage';
import ProfitPage from './ProfitPage';
import AreaControlPage from './AreaControlPage';

export default function AdminPage({ onLogout, darkMode, toggleDarkMode }) {
  const [currentView, setCurrentView] = useState('control');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split('/').pop();
    if (path === 'admin') {
      setCurrentView('control');
    } else {
      setCurrentView(path);
    }
  }, [location]);

  const showToast = (message, type = 'info') => {
    Swal.fire({
      icon: type,
      title: message,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });
  };

  const handleNavigation = (view) => {
    setCurrentView(view);
    navigate(`/admin/${view}`);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className={`admin-page ${darkMode ? 'dark-mode' : ''}`}>
      <nav className="navbar">
        <div className="navbar-brand">Panel de Administración</div>
        <button className="hamburger" onClick={toggleMenu}>
          <HiOutlineMenu />
        </button>
        <ul className={`navbar-nav ${isMenuOpen ? 'active' : ''}`}>
          <NavItem icon={<HiOutlineUser />} label="Usuarios" view="users" currentView={currentView} onClick={() => handleNavigation('users')} />
          <NavItem icon={<HiOutlineClipboardCheck />} label="Control" view="control" currentView={currentView} onClick={() => handleNavigation('control')} />
          <NavItem icon={<HiOutlineDocumentText />} label="Notas" view="notas" currentView={currentView} onClick={() => handleNavigation('notas')} />
          <NavItem icon={<HiOutlineCash />} label="Presupuesto" view="presupuestos" currentView={currentView} onClick={() => handleNavigation('presupuestos')} />
          <NavItem icon={<HiOutlineCash />} label="Areas" view="areas" currentView={currentView} onClick={() => handleNavigation('area')} />
          <li className="nav-item dark">
            <button onClick={toggleDarkMode} className="nav-link">
              {darkMode ? <HiOutlineSun className="icon darkm" /> : <HiOutlineMoon className="icon" />}
            </button>
          </li>
          <li className="nav-item">
            <button onClick={onLogout} className="nav-link logout-button">
              <HiOutlineLogout className="icon" />
            </button>
          </li>
        </ul>
      </nav>

      <main className="main-content">
        <Routes>
          <Route path="users" element={<UserControlPage />} />
          <Route path="control" element={<ControlPage />} />
          <Route path="notas" element={<NotesPage />} />
          <Route path="presupuestos" element={<ProfitPage />} />
          <Route path="area" element={<AreaControlPage />} />
          <Route path="*" element={<ControlPage />} />
        </Routes>
      </main>
    </div>
  );
}

function NavItem({ icon, label, view, currentView, onClick }) {
  return (
    <li className={`nav-item ${currentView === view ? 'active' : ''}`}>
      <button onClick={onClick} className="nav-link">
        {icon}
        <span className="nav-label">{label}</span>
      </button>
    </li>
  );
}

